// Date 2020-07-24 14:09:42

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";

import inspectionScheduleEdit from "@/views/em/inspection/InspectionScheduleEdit.vue";
import inspectionScheduleList from "@/views/em/inspection/InspectionScheduleList.vue";
import inspectionScheduleEquipmentEdit from "@/views/em/inspection/InspectionScheduleEquipmentEdit.vue";
import inspectionScheduleEquipmentList from "@/views/em/inspection/InspectionScheduleEquipmentList.vue";
import inspectionWorkOrderEdit from "@/views/em/inspection/InspectionWorkOrderEdit.vue";
import inspectionWorkOrderList from "@/views/em/inspection/InspectionWorkOrderList.vue";
import inspectionWorkOrderTask from "@/views/em/inspection/InspectionWorkOrderTask.vue";
import inspectionRecordEdit from "@/views/em/inspection/InspectionRecordEdit.vue";
import inspectionRecordList from "@/views/em/inspection/InspectionRecordList.vue";
import inspectionRecordTask from "@/views/em/inspection/InspectionRecordTask.vue";
import inspectionScheduleTimeoutRecordEdit from "@/views/em/inspection/InspectionScheduleTimeoutRecordEdit.vue";
import inspectionScheduleTimeoutRecordList from "@/views/em/inspection/InspectionScheduleTimeoutRecordList.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/inspection/inspectionCategory/list",
        name: "inspectionCategoryList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionCategory/edit",
        name: "inspectionCategoryEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionResult/list",
        name: "inspectionResultList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionResult/edit",
        name: "inspectionResultEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionValueType/list",
        name: "inspectionValueTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionValueType/edit",
        name: "inspectionValueTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionWay/list",
        name: "inspectionWayList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionWay/edit",
        name: "inspectionWayEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionStandard/list",
        name: "inspectionStandardList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionStandard/edit",
        name: "inspectionStandardEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionScheduleDetail/list",
        name: "inspectionScheduleDetailList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionScheduleDetail/edit",
        name: "inspectionScheduleDetailEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/inspection/inspectionScheduleEdit",
        name: "inspectionScheduleEdit",
        component: inspectionScheduleEdit,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionScheduleList",
        name: "inspectionScheduleList",
        component: inspectionScheduleList,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionScheduleEquipmentEdit",
        name: "inspectionScheduleEquipmentEdit",
        component: inspectionScheduleEquipmentEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionScheduleEquipmentList",
        name: "inspectionScheduleEquipmentList",
        component: inspectionScheduleEquipmentList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionWorkOrderEdit",
        name: "inspectionWorkOrderEdit",
        component: inspectionWorkOrderEdit,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionWorkOrderList",
        name: "inspectionWorkOrderList",
        component: inspectionWorkOrderList,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionWorkOrderTask",
        name: "inspectionWorkOrderTask",
        component: inspectionWorkOrderTask,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionRecordEdit",
        name: "inspectionRecordEdit",
        component: inspectionRecordEdit,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionRecordList",
        name: "inspectionRecordList",
        component: inspectionRecordList,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionRecordTask",
        name: "inspectionRecordTask",
        component: inspectionRecordTask,
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionScheduleTimeoutRecordEdit",
        name: "inspectionScheduleTimeoutRecordEdit",
        component: inspectionScheduleTimeoutRecordEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/inspection/inspectionScheduleTimeoutRecordList",
        name: "inspectionScheduleTimeoutRecordList",
        component: inspectionScheduleTimeoutRecordList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]